<script>
    import SingleDay from './SingleDay.svelte';
    let loading = true;
    let fallback = false;
    let days = [{
        date: "AUSFALL",
        persons: [
            {vorname: "Bastian", nachname: "Bringenberg", email: "bastian@pottkinder.de", handynummer: "+4915122927052", privatnummer: "+491772357214", verfuegbar: true},
            {vorname: "Nico", nachname: "von Heymann", email: "nico@pottkinder.de", handynummer: "+4915777414629", privatnummer: "+4915259280060", verfuegbar: true},
            {vorname: "Denis", nachname: "Pazer", email: "denis@pottkinder.de", handynummer: "+4915777441263", privatnummer: "+4915789719371", verfuegbar: true}

        ]
    }];

    export async function fetchPersonData() {
        try {
            const res = await fetch(
                'https://emergency.pottkinder.dev/api/',
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await res.json();
            console.log(data);
            days = data;
            fallback = false;
            loading = false;
        } catch (error) {
            console.log('There was an error', error);
            fallback = true;
            loading = false;
        }
        
    }
    fetchPersonData();

    let openIndex = 0; 
    function toggleAccordion(index) {
        openIndex = openIndex === index.detail ? null : index.detail;
    }
</script>

<div data-type="Contact" class="my-3">
    {#if loading}
        <div class="px-8">
            Kontakte laden...
        </div>
    {:else}
        {#if fallback}
            <div data-type="fallback" class="italic px-8">
                <h2>Es konnten keine Daten geladen werden!</h2>
                <p>Leider konnten die aktuellen Kontaktdaten nicht geladen werden, daher sind hier die alten Daten zu finden:</p>
            </div>
        {/if}
        <div data-type="days">
            {#each days as day, index}
                <SingleDay 
                    {day} 
                    {index}
                    {openIndex}
                    on:toggle={toggleAccordion}    
                />
            {/each}
        </div>
    {/if}
</div>